export enum FeatureFlagName {
	webHaspCodes = 'webHaspCodes',
	enableUpdatedSysAdmin = 'enableUpdatedSysAdmin',
	enableInstallPhotoManagement = 'enableInstallPhotoManagement',
	transferDeviceUpdates = 'transferDeviceUpdates',
	supportRole = 'supportRole',
	enableSenturian = 'enableSenturian',
	enableClarityTracking = 'enableClarityTracking',
}
